// extracted by mini-css-extract-plugin
module.exports = {"positive":"Balance_positive__3zyTI","icon":"Balance_icon__2ys14","box":"Balance_box__37590","box1":"Balance_box1__1xdIs","box2":"Balance_box2__2iHUK","box3":"Balance_box3__1iInj"};